import { Base } from '@studiometa/js-toolkit';

/**
 * SecretProperty component
 * Reads secret params from URL and displays them as a line item property
 */
export default class SecretProperty extends Base {
  static config = {
    name: 'SecretProperty',
    refs: ['input', 'summary'],
    options: {
      locale: { type: String, default: 'fr' },
    },
  };

  /**
   *
   */
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const location = params.get('secret_location') || '';
    const dateStr = params.get('secret_date') || '';
    const timeStr = params.get('secret_time') || '';

    if (!location && !dateStr && !timeStr) return;

    let summary = location;
    if (dateStr) {
      const date = new Date(dateStr);
      const formatted = date.toLocaleDateString(this.$options.locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      summary += summary ? `, ${formatted}` : formatted;
    }
    if (timeStr) {
      const [h, m] = timeStr.split(':');
      summary += ` — ${h}h${m}`;
    }

    this.$refs.summary.textContent = summary;
    if (this.$refs.input) {
      this.$refs.input.value = summary;
      this.$refs.input.disabled = false;
    }
    this.$el.hidden = false;
  }
}
